import { combineReducers } from '@reduxjs/toolkit'
import previewMerchant from './preview-merchant.store'
import attachInvoiceFile from './attach-invoice-file.store'

export const rootReducer = combineReducers({
  previewMerchant,
  attachInvoiceFile,
})
